import styled, { css } from "styled-components";

import Text from "../Text";

interface IAccordionHeaderProps {
  active?: boolean;
}

export const StyledLink = styled(Text)<IAccordionHeaderProps>`
  padding: 5px 0 5px 25px;
  &:hover {
    background: #f3f3f3;
  }
  ${(props) =>
        props.active &&
    css`
      background: #f3f3f3;
    `}
`;
